var _rect, _path, _rect2, _path2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomizationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 70,
    height: 70,
    rx: 35,
    fill: "#F5F5F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.14 19.854h13c1.196 0 2.166.97 2.166 2.166v14.083c0 1.197-.97 2.167-2.167 2.167h-19.5a2.167 2.167 0 01-2.166-2.167V22.02c0-1.196.97-2.166 2.166-2.166h6.5zm-2.167 2.166h-4.334v3.25h4.334v-3.25zm2.166 3.25v-3.25h13v3.25h-13zm-2.166 2.167h-4.334v3.25h4.334v-3.25zm2.166 3.25v-3.25h13v3.25h-13zm-2.166 2.166h-4.334v3.25h4.334v-3.25zm2.166 3.25v-3.25h13v3.25h-13z",
    fill: "#9BAEF1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.264,
    y: 30.27,
    width: 24.5,
    height: 21.875,
    rx: 2,
    fill: "#F5F5F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.514 35.207a2 2 0 104 0 2 2 0 00-4 0zm6-1h14v2h-14v-2zm14 6h-14v2h14v-2zm-14 8h14v-2h-14v2zm-6-1a2 2 0 104 0 2 2 0 00-4 0zm2-4a2 2 0 110-4 2 2 0 010 4z",
    fill: "#506BCA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 70,
    height: 70,
    rx: 35,
    stroke: "#F5F5F8",
    strokeWidth: 2
  })));
}
export default __webpack_public_path__ + "media/virtualStagingContractMedia/customizationIcon-21d16da8.svg";
export { SvgCustomizationIcon as ReactComponent };